import { Chip } from '@mui/material';
import { TagDto } from '@sr/dto';
import { Color } from 'utils/color-helper';
type Props = {
  tag: Omit<TagDto, 'tagLinks'> & Partial<Pick<TagDto, 'tagLinks'>>;
};

export const Tag = ({ tag } : Props) => {
  return <Chip label={tag.name} sx={{ backgroundColor: tag.color, color: Color.fromHex(tag.color).contrast().toHex() }} />;
};
